// 폴리곤 테스트 넷
import { CHAIN_NAMESPACES, WEB3AUTH_NETWORK, type IProvider } from '@web3auth/base';
import { BUILD_ENV, OPENLOGIN_NETWORK, OpenloginAdapter } from '@web3auth/openlogin-adapter';
import { MetamaskAdapter } from '@web3auth/metamask-adapter';
import { WalletServicesPlugin } from '@web3auth/wallet-services-plugin';

import { WalletConnectModal } from '@walletconnect/modal';
import { getWalletConnectV2Settings, WalletConnectV2Adapter } from '@web3auth/wallet-connect-v2-adapter';
import { COIN_NAME_POL } from '../common/name-space';

export const chainConfig = {
  chainId: '0x13882', // amoy 폴리곤 테스트 넷
  rpcTarget: 'https://polygon-amoy.blockpi.network/v1/rpc/public',
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  displayName: 'Amoy',
  blockExplorerUrl: 'https://amoy.polygonscan.com/',
  ticker: COIN_NAME_POL,
  tickerName: 'TMATIC',
  logo: 'https://images.toruswallet.io/eth.svg',
};

export const metamaskAdapter = new MetamaskAdapter({
  clientId: process.env.REACT_APP_WEB3_AUTH_CLIENT_ID!,
  sessionTime: 3600, // 1 hour in seconds
  web3AuthNetwork: OPENLOGIN_NETWORK.SAPPHIRE_DEVNET,
  chainConfig: {
    chainNamespace: CHAIN_NAMESPACES.EIP155,
    chainId: '0x13882', // amoy 폴리곤 테스트 넷
    rpcTarget: 'https://polygon-amoy.blockpi.network/v1/rpc/public', // This is the public RPC we have added, please pass on your own endpoint while creating an app
  },
});

export const walletServicesPlugin = new WalletServicesPlugin();

// const defaultWcSettings = await getWalletConnectV2Settings('eip155', ['80002'], '2bc1c65293813d37518812ef30760cab');
// const walletConnectModal = new WalletConnectModal({ projectId: '2bc1c65293813d37518812ef30760cab' });
// export const walletConnectV2Adapter = new WalletConnectV2Adapter({
//   adapterSettings: { qrcodeModal: walletConnectModal, ...defaultWcSettings.adapterSettings },
//   loginSettings: { ...defaultWcSettings.loginSettings },
// });
